import { KeyboardEvent, useEffect, useRef, useState } from 'react';
import './questionAndAnswerTicket.scss';
import {
  fetchApiGet,
  fetchApiPost,
  fetchApiPut,
  fetchApiUploadFile,
  formatFileSize,
  getFileIcon,
  getQaRate,
  isGroupCtv,
  isValid,
} from '../../../../utils/helper';
import { MEDIA_TYPE, QA_TICKET_STATUS, ROLE_NAME, STATUS_RATE } from 'utils/data';
import { Dropdown, Image, Menu, Spin } from 'antd';
import toast, { NotifyType } from 'utils/toast';
import { AppState } from 'interface/stateApp';
import { ExerciseFormat } from 'model/response';
import LectureTheoryModal from 'component/common/LectureTheoryModal';
import { Detail, Ticket } from '../../../../model/QnA';
import { useMasterUserSelector } from '../../../../redux/selector';
import { API_GET_QA_MESSAGE, API_GET_QA_TICKET_DETAIL, API_POST_MESSAGE } from '../../../../config/data';
import AttachTheoryModal from '../components/attachTheory';

interface QaFormProps {
  ticket?: Ticket | null;
  onData?: any;
  modalKey: any;
}

function QuestionAndAnswerTicket({ ticket, onData, modalKey }: QaFormProps) {
  const [currentTicket, setCurrentTicket] = useState<Ticket | null>(null);
  const user = useMasterUserSelector();
  const [currentMsg, setCurrentMsg] = useState<Partial<Detail>>({});
  const [messages, setMessages] = useState<Detail[]>([]);
  const [filterMsg, setFilterMsg] = useState<Detail[]>([]);
  const messageEndRef = useRef<HTMLDivElement>(null);
  const [isInputVisible, setIsInputVisible] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchMsg, setSearchMsg] = useState('');
  const [uploading, setUploading] = useState(false);
  const [attachTheoryKey, setAttachTheoryKey] = useState<any>();
  const [lectureTheoryModalData, setLectureTheoryModalData] = useState<{
    type: 'LECTURE' | 'THEORY';
    id: string | null;
    open: boolean;
  }>({
    type: 'LECTURE',
    id: null,
    open: false,
  });

  const referenceImage = '/assets/images/document_attach.jpg';
  const colaboratorAvt = '/assets/images/ctv.svg';
  const studentAvt = '/assets/images/student.jpg';
  const ticketImage = '/assets/images/ticket.png';

  const scrollToRef = useRef<HTMLDivElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [stateApp, setStateApp] = useState<AppState>({
    showAttachTheoryForm: false,
  });

  const handleSearchMsgChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isValid(currentTicket)) {
      const value = event.target.value;
      setSearchMsg(value);
      var msgs = isValid(messages) ? messages : [];
      if (msgs !== undefined && msgs !== null) {
        const filtered = msgs.filter(
          (msg) =>
            msg?.message?.toLowerCase().includes(value.toLowerCase()) ||
            msg?.fileUpload?.fileName.toLowerCase().includes(value.toLowerCase()),
        );
        setFilterMsg(filtered);
      }
    }
  };

  const handleFileIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploading(true);
      const formData = new FormData();
      formData.append('file', file);
      const data: any = await fetchApiUploadFile(formData);
      if (data !== null) {
        if (data.status === 1) {
          let msg = {
            ...currentMsg,
            ticketId: currentTicket?.id,
            fileUpload: {
              url: data.url,
              fileName: data.fileName,
              typeFile: data.typeFile,
              size: data.size,
            },
          };
          sendMessageFileUpload(msg);
        } else {
          toast(NotifyType.ERROR, 'Tải file lên thất bại!');
          return;
        }
      } else {
        toast(NotifyType.ERROR, 'Tải file lên thất bại!');
      }
      setUploading(false);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset giá trị của input file
    }
  };

  const getTicketData = async () => {
    if (ticket) {
      handleSelectTicket(ticket);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
      setIsInputVisible(false);
    }
  };

  const fetchPostMessage = async (message: Detail) => {
    const messageToSend = {
      ...message,
      fileUpload: message.fileUpload ? JSON.stringify(message.fileUpload) : null,
    };
    const data: any = await fetchApiPost(API_POST_MESSAGE, messageToSend, MEDIA_TYPE.JSON);
    if (data !== null) {
      console.log(data);
      setMessages((prevMessages) => {
        if (!Array.isArray(prevMessages)) {
          return [data];
        }
        return [...prevMessages, data];
      });
      setFilterMsg((prevMessages) => {
        if (!Array.isArray(prevMessages)) {
          return [data];
        }
        return [...prevMessages, data];
      });
    }
  };
  const sendMessage = (reference?: ExerciseFormat) => {
    if ((currentMsg?.message !== undefined && currentMsg?.message.trim() !== '') || reference) {
      let message = {
        ...currentMsg,
        ticketId: currentTicket?.id,
        referenceId: reference ? reference?.id : null,
      };
      fetchPostMessage(message);
      setCurrentMsg({});
    }
  };

  const sendMessageFileUpload = (msg: Detail) => {
    fetchPostMessage(msg);
    setCurrentMsg({});
  };

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      sendMessage();
    }
  };

  const GetTicketDetail = async (ticket: Ticket) => {
    const data: any = await fetchApiGet(`${API_GET_QA_MESSAGE}${ticket.id}`);
    if (data !== null) {
      setCurrentTicket(ticket);
      setMessages(data);
      setFilterMsg(data);
    }
  };

  const handleSelectTicket = (ticket: Ticket) => {
    GetTicketDetail(ticket);
  };

  const handleCloseTicket = async () => {
    if (
      user?.role === ROLE_NAME.ROLE_STUDENT ||
      currentTicket?.status === QA_TICKET_STATUS.CLOSE ||
      !isValid(currentTicket?.colaboratorId) ||
      !currentTicket?.receive
    ) {
      toast(NotifyType.WARNING, 'Không thể thực hiện');
      return;
    }
    const data: any = { ...currentTicket, status: QA_TICKET_STATUS.CLOSE };
    console.log(data);
    const response = await fetchApiPut(`${API_GET_QA_TICKET_DETAIL}${currentTicket?.id}`, data, MEDIA_TYPE.JSON);
    if (response !== null) {
      setCurrentTicket(data);
      if (onData) {
        onData(data);
      }
      toast(NotifyType.SUCCESS, 'Kết thúc phiếu hỏi thành công!');
    } else {
      toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
    }
  };
  const menu = (
    <Menu>
      {user?.role === ROLE_NAME.ROLE_STUDENT ? (
        <Menu.Item key="report">Báo cáo</Menu.Item>
      ) : (
        <Menu.Item key="end-conversation" onClick={handleCloseTicket}>
          Kết thúc hội thoại
        </Menu.Item>
      )}
    </Menu>
  );

  const handleOpenAttachTheoryModal = () => {
    setAttachTheoryKey(Date.now());
    setStateApp({ ...stateApp, showAttachTheoryForm: true });
  };

  const handleOpenLecture = (exerciseFormat: ExerciseFormat) => {
    if (!exerciseFormat?.lecture?.id) {
      toast(NotifyType.WARNING, 'Không có bài giảng cho dạng bài tập này');
      return;
    }
    setLectureTheoryModalData({
      type: 'LECTURE',
      open: true,
      id: exerciseFormat?.lecture?.id,
    });
  };

  const handleOpenTheory = async (exerciseFormat: ExerciseFormat) => {
    if (!exerciseFormat?.theory?.id) {
      toast(NotifyType.WARNING, 'Không có lý thuyết cho dạng bài tập này');
      return;
    }
    setLectureTheoryModalData({
      type: 'THEORY',
      open: true,
      id: exerciseFormat?.theory?.id,
    });
  };

  const onDataAttach = (value: ExerciseFormat) => {
    console.log(value);
    sendMessage(value);
  };
  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollTop = messageEndRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    getTicketData();
  }, [ticket, modalKey]);

  useEffect(() => {
    if (isInputVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isInputVisible]);

  return (
    <div className="qa-container qa-container-display-small-screen" ref={scrollToRef}>
      <AttachTheoryModal
        stateApp={stateApp}
        setStateApp={setStateApp}
        subjectId={currentTicket?.subjectId}
        key={attachTheoryKey}
        onData={onDataAttach}
      />
      <LectureTheoryModal
        open={lectureTheoryModalData.open}
        id={lectureTheoryModalData.id}
        type={lectureTheoryModalData.type}
        onCancel={() =>
          setLectureTheoryModalData({
            type: 'LECTURE',
            id: null,
            open: false,
          })
        }
      />
      <div className="qa-header qa-row">
        <div className="chat-header qa-col-2">
          <h3>
            {currentTicket !== null && currentTicket !== undefined ? currentTicket?.ticketName : 'Nội dung phiếu hỏi'}
          </h3>
          <div className="chat-header-toolbar">
            <div className={`chat-header-search-container ${isInputVisible ? 'visible' : ''}`}>
              <input
                ref={inputRef}
                type="text"
                className="qa-search-input"
                placeholder="Search..."
                value={searchMsg}
                onChange={handleSearchMsgChange}
              />
            </div>
            {!isInputVisible ? (
              <i className="fa-solid fa-magnifying-glass" onClick={() => setIsInputVisible(true)}></i>
            ) : null}
            <Dropdown overlay={menu} trigger={['click']}>
              <i className="fa-solid fa-ellipsis-vertical rounded-full bg-[#f1f1f1] px-[10px] py-1 ml-2"></i>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="qa-row qa-row-2">
        {currentTicket !== undefined ? (
          currentTicket?.colaborator && (
            <div className="chat-header-details qa-col-2">
              <img
                src={currentTicket?.colaborator?.imageUrl ? currentTicket?.colaborator?.imageUrl : colaboratorAvt}
                alt="Profile"
                className="profile-image"
              />
              <div>
                <span>{currentTicket?.colaborator.fullName}</span>
                <div className="chat-header-subtitle">GV. Hóa Học</div>
              </div>
            </div>
          )
        ) : (
          <div className="qa-col-2"></div>
        )}
      </div>
      <div className="qa-main-container qa-row">
        {currentTicket !== undefined ? (
          <div className="chat-container qa-col-2">
            <div className="chat-messages" ref={messageEndRef}>
              {filterMsg?.map((detail) => (
                <div
                  className={`message-container ${detail.fromUser === user?.id || user?.role === ROLE_NAME.ROLE_ADMIN || isGroupCtv(detail?.roleUser) ? 'message-user-sent' : ''}`}
                  key={detail?.id}
                >
                  <img
                    src={user?.role === ROLE_NAME.ROLE_STUDENT ? studentAvt : colaboratorAvt}
                    alt="Profile"
                    className="message-profile-image"
                  />
                  <div className="msg-content-container">
                    <div className="msg-content">
                      {detail?.message !== undefined && detail.message !== null && detail?.message.trim() !== '' ? (
                        <pre
                          className={
                            detail.fromUser === user?.id ||
                            user?.role === ROLE_NAME.ROLE_ADMIN ||
                            isGroupCtv(detail?.roleUser)
                              ? 'msg-content-sent'
                              : ''
                          }
                        >
                          {detail.message}
                        </pre>
                      ) : null}
                    </div>
                    {detail?.referenceId && detail?.referenceId !== '' ? (
                      <div className="reference-container">
                        <img
                          src={detail?.reference?.thumbnails ? detail?.reference?.thumbnails : referenceImage}
                          alt="Example"
                          className="max-h-[25vh]"
                        />
                        <div className="reference-controller pt-1">
                          <button
                            className="btn-reference btn-reference-lesson mr-[15px]"
                            onClick={() => handleOpenLecture(detail?.reference)}
                          >
                            Bài giảng
                          </button>
                          <button
                            className="btn-reference btn-reference-theory"
                            onClick={() => handleOpenTheory(detail?.reference)}
                          >
                            Lý thuyết
                          </button>
                        </div>
                      </div>
                    ) : detail?.fileUpload !== null && detail?.fileUpload !== undefined ? (
                      detail.fileUpload.typeFile.includes('image') ? (
                        <div className="referent-container-image">
                          <Image src={detail.fileUpload.url} alt="Example" />
                        </div>
                      ) : (
                        <div
                          className={`qa-file-container ${detail.fromUser === user?.id || user?.role === ROLE_NAME.ROLE_ADMIN || isGroupCtv(detail?.roleUser) ? 'msg-content-sent' : ''}`}
                        >
                          <div className="qa-file-child-1">
                            <img
                              src={getFileIcon(detail.fileUpload.typeFile)}
                              alt="file"
                              className="qa-file-icon"
                            ></img>
                            <div className="qa-child-empty"></div>
                          </div>
                          <div className="qa-file-child">
                            <span className="qa-file-name">{detail.fileUpload.fileName}</span>
                            <div className="qa-file-child-child">
                              <p>{formatFileSize(detail.fileUpload.size)}</p>
                              <a
                                href={detail?.fileUpload.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="qa-file-download"
                              >
                                <i className="fa-solid fa-download"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      )
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
            {user?.role === ROLE_NAME.ROLE_ADMIN && getQaRate(currentTicket?.rates) !== undefined ? (
              <div className="w-[100%] mt-10 p-1 bg-gray-50 rounded-md">
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="rating">
                    Đánh giá:
                  </label>
                  <input
                    className="w-full px-3 py-2 border rounded-md bg-gray-200 text-gray-700 outline-none"
                    id="rating"
                    type="text"
                    value={getQaRate(currentTicket?.rates)?.status === STATUS_RATE.GOOD ? 'Hài lòng' : 'Không hài lòng'}
                    readOnly
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="content">
                    Nội dung:
                  </label>
                  <textarea
                    className="outline-none w-full h-[30] px-3 py-2 border rounded-md bg-gray-100 text-gray-700 resize-none overflow-y-auto"
                    id="content"
                    value={getQaRate(currentTicket?.rates)?.message}
                    readOnly
                  />
                </div>
              </div>
            ) : (currentTicket?.status === QA_TICKET_STATUS.OPEN ||
                currentTicket?.status === QA_TICKET_STATUS.PROCESS) &&
              isGroupCtv(user?.role) ? (
              <div className="message-input-container">
                <div className="message-toolbar message-input-container-child">
                  <div className="message-toolbar message-input-container-child">
                    {uploading ? (
                      <Spin className="qa-spin-container"></Spin>
                    ) : (
                      <i className="fa-solid fa-paperclip" onClick={handleFileIconClick}></i>
                    )}
                  </div>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rar,.zip,.pdf"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                </div>
                <div
                  className="message-toolbar bg-[#12177E] text-[#ffff] rounded-2xl px-2 py-[3px] cursor-pointer"
                  onClick={handleOpenAttachTheoryModal}
                >
                  Trích dẫn lý thuyết
                </div>
                <div className="message-input-container-child message-input-container-message">
                  <input
                    type="text"
                    placeholder="Nhập nội dung tin nhắn"
                    className="message-input"
                    onChange={(e) => setCurrentMsg({ ...currentMsg, message: e.target.value })}
                    onKeyDown={handleKeyPress}
                    value={currentMsg?.message === undefined ? '' : currentMsg.message}
                  />
                  <img src="/assets/icons/icon_send.svg" alt="send" onClick={() => sendMessage}></img>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ) : (
          <div className="qa-col-2 qa-none-container">
            <img src={ticketImage} alt="ticket"></img>
            <h3>Bạn không có phiếu hỏi nào!</h3>
          </div>
        )}
      </div>
    </div>
  );
}

export default QuestionAndAnswerTicket;
